import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Gallery from "@/components/Gallery";
import { Reveal, Overline } from "@/components/motion";
import { getGallery } from "@/lib/api";
import { CONTACT_INFO, IMAGES } from "@/data/demo";

const QuiSommesNous = () => {
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    getGallery("qui_sommes_nous").then(setGallery);
  }, []);

  return (
    <div data-testid="qui-sommes-nous-page">
      <PageHero
        testId="qsn-hero"
        contentKey="quisommesnous"
        image={IMAGES.aerial}
        overline="La structure"
        titleLines={[
          <span key="a" className="text-white">QUI SOMMES-</span>,
          <span key="b" className="text-gold">NOUS ?</span>,
        ]}
        subtitle="3M Match Pro est une structure spécialisée dans l'organisation de stages de football et de matchs amicaux professionnels et semi-professionnels."
      />

      <section data-testid="qsn-presentation" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-5">
            <Overline>Notre ADN</Overline>
            <h2 className="mt-4 font-display uppercase text-4xl sm:text-5xl leading-[0.9] tracking-tight">
              Le football, <span className="text-gold">avec exigence</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7 space-y-5">
            <p className="text-white/70 leading-relaxed text-base md:text-lg">
              Basés en France, nous organisons des stages de perfectionnement pour les jeunes
              joueuses et joueurs.
            </p>
            <p className="text-white/70 leading-relaxed text-base md:text-lg">
              Notre engagement : un encadrement sérieux, des événements soignés dans les moindres détails
              et une expérience digne du haut niveau, sur le terrain comme en dehors.
            </p>
            <p className="text-white/70 leading-relaxed text-base md:text-lg">
              Une question ? Contactez-nous au {CONTACT_INFO.telephones[0].number} (Sylvain) ou au{" "}
              {CONTACT_INFO.telephones[1].number} (Kader), ou par email à {CONTACT_INFO.email}.
            </p>
          </Reveal>
        </div>
      </section>

      <div className="bg-[#0a0a0a] border-y border-white/5">
        <Gallery items={gallery} title="En images" overline="Photos & vidéos" testId="gallery-qsn" />
      </div>

      <section data-testid="qsn-cta" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <Reveal>
          <div className="relative border border-gold/25 p-10 md:p-16 overflow-hidden">
            <div
              className="absolute inset-0"
              style={{ background: "radial-gradient(ellipse 50% 60% at 80% 20%, rgba(212,175,55,0.1), transparent)" }}
            />
            <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-8">
              <div>
                <h2 className="font-display uppercase text-4xl sm:text-5xl leading-[0.9] tracking-tight">
                  Envie de nous <span className="text-gold">rejoindre</span> ?
                </h2>
                <p className="mt-3 text-white/60 max-w-md">
                  Découvrez nos stages ou parlez-nous de votre projet de match amical.
                </p>
              </div>
              <div className="flex flex-wrap gap-4 shrink-0">
                <Link
                  to="/stage-payet"
                  data-testid="qsn-cta-stages"
                  className="px-8 py-4 bg-rouge text-white text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-rouge-hover hover:scale-[1.02] active:scale-95 transition-all shadow-[0_0_20px_rgba(230,0,0,0.3)] inline-flex items-center gap-3"
                >
                  Voir les stages <ArrowRight size={16} />
                </Link>
                <Link
                  to="/contact"
                  data-testid="qsn-cta-contact"
                  className="px-8 py-4 border-2 border-gold text-gold text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-gold hover:text-noir transition-all"
                >
                  Nous contacter
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
};

export default QuiSommesNous;
